import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { TestDriveInfoTable } from './DisplayTestDriveInfo';

function PicksModal(props){
  const {
    picks,
    buttonClassName,
    color
  } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const basicTitle = 'Your Picks';
  const numProspects = picks.length;
  const linkText = (numProspects>0) ? basicTitle+' ('+numProspects+')' : basicTitle;
  
  //use animation={false} with Modal to avoid findDOMNode deprecation warning (but that will turn off the pretty transition)
  return(
  <>
    <Button className={buttonClassName} color={color || "link"} onClick={toggleModal}>{linkText}</Button>
    <Modal isOpen={isModalOpen} toggle={toggleModal} size="lg">
      <ModalHeader toggle={toggleModal}>{basicTitle}</ModalHeader>
      <ModalBody>
        {numProspects>0
          ? <TestDriveInfoTable testDrives={picks} />
          : <><p>You haven't made any Picks yet.</p>
            </>
        }
      </ModalBody>
    </Modal>
  </>
  );
}

export default PicksModal;

// challenges getting small images to render, when passed in to dangerouslySetInnerHTML
// attempts using import smallImage from './small.png';
// {/* DOES display the small image: <ModalBody><img src={smallImage}/></ModalBody> */}
// {/* does not display the small image, smallImage used literally: <ModalBody><span dangerouslySetInnerHTML={{__html: `<img src={smallImage}/>`}}></span></ModalBody> */}
// {/* does not display: image is base64 <ModalBody><span dangerouslySetInnerHTML={{__html: `<img src=${smallImage}/>`}}></span></ModalBody> */}
// attempts using require()
// {/* DOES display the small image: <ModalBody><img src={require("./small.png")}/></ModalBody> */}
// {/* does not display: image is base64 <ModalBody><span dangerouslySetInnerHTML={{__html: `<img src=${require("./small.png")}/>`}}></span></ModalBody> */}   
// ** WHAT DOES WORK is putting the image in /public.
